import { initSentry } from "@/sentry";
// Initialize Sentry BEFORE any app rendering — must be the first runtime
// statement so global error handlers are installed up-front.
initSentry();

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
// After index.css on purpose: these rules must win over Tailwind utilities.
import "@/styles/layout.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA: Only activate on internal ATS pages (login + /app/*), NOT the marketing website
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const path = window.location.pathname;
    const isInternalPage = path.startsWith('/teamlogin') || path.startsWith('/app/') || path === '/forgot-password';
    if (isInternalPage) {
      // Inject manifest link dynamically so marketing pages never trigger PWA
      if (!document.querySelector('link[rel="manifest"]')) {
        const link = document.createElement('link');
        link.rel = 'manifest';
        link.href = '/manifest.json';
        document.head.appendChild(link);
      }
      navigator.serviceWorker.register('/service-worker.js').catch(() => {});
    } else {
      // On marketing pages: unregister any previously cached service worker
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const reg of registrations) {
          reg.unregister();
        }
      });
    }
  });
}
